exports = module.exports = require("../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "\n.box[data-v-1011a4a0]{\n    padding: .3rem;\n}\n.title[data-v-1011a4a0] {\n  font-size: 0.3rem;\n  line-height: 0.42rem;\n  color: #333;\n  margin-bottom: .24rem;\n}\n.time[data-v-1011a4a0]{\n    color: #999;\n    font-size: .24rem;\n    margin-bottom: .3rem;\n}\n.content[data-v-1011a4a0]{\n    font-size: .28rem;\n    line-height: .38rem;\n}\n", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./node_modules/css-loader?{"sourceMap":false}!./node_modules/vue-loader/lib/style-compiler?{"vue":true,"id":"data-v-1011a4a0","scoped":true,"hasInlineConfig":false}!./node_modules/vue-loader/lib/selector.js?type=styles&index=0&bustCache!./src/components/jokeDetail.vue
// module id = eX+d
// module chunks = 1